import React, { useState } from "react";
import {
  Navbar,
  NavbarBrand,
  NavbarToggler,
  Collapse,
  Nav,
  NavItem,
  NavLink,
  Container,
} from "reactstrap";
import Logo from "./Logo";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHome,
  faUsers,
  faServer,
  faEnvelope,
} from "@fortawesome/free-solid-svg-icons";
import { Link, useLocation } from "react-router-dom";
import "./common.css";

const navItems = [
  { label: "Home", href: "/", icon: faHome },
  { label: "Who We Are", href: "/whoweare", icon: faUsers },
  { label: "Hosting", href: "/hosting", icon: faServer },
  { label: "Contact", href: "/contact", icon: faEnvelope },
];

export default function Header() {
  const [isOpen, setIsOpen] = useState(false);
  const { pathname } = useLocation();

  const toggle = () => setIsOpen((open) => !open);

  return (
    <Navbar
      expand="md"
      className="header-appbar sticky-top py-3"
    >
      <Container className="d-flex align-items-center">
        <NavbarBrand
          tag={Link}
          to="/"
          className="header-logo-link d-flex align-items-center"
        >
          <Logo size={44} text="Social Media" />
        </NavbarBrand>
        <NavbarToggler onClick={toggle} className="border-0" />
        <Collapse isOpen={isOpen} navbar>
          <Nav className="ms-auto align-items-center" navbar>
            {navItems.map(({ label, href, icon }) => (
              <NavItem key={href}>
                <NavLink
                  tag={Link}
                  to={href}
                  className={`header-nav-link px-3${pathname === href ? " active" : ""}`}
                  onClick={() => setIsOpen(false)}
                >
                  <FontAwesomeIcon icon={icon} className="me-2" />
                  {label}
                </NavLink>
              </NavItem>
            ))}
          </Nav>
        </Collapse>
      </Container>
    </Navbar>
  );
}
